<page-heading [title]="'kanban.product.pageTitle' | translate" [description]="'kanban.product.pageDescription' | translate" />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-9 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              [placeholder]="'kanban.product.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)"
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-lg-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="add()">{{ 'kanban.product.add' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
  <content-loading-list />
}

@if (pager.total === 0) {
  <empty-records-component
    [message]="'kanban.product.emptyMessage' | translate"
    [subMessage]="'kanban.product.emptySubMessage' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
    [labelButton]="'kanban.product.add' | translate"
    (emitEvent)="add()"
  />
}

@if (!loadingContent && pager.total > 0) {
  <div class="card">
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'kanban.product.colName' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'kanban.product.colDescription' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'kanban.product.colPrice' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'kanban.product.colCode' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'kanban.product.colStatus' | translate }}</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track $index) {
            <tr>
              <td class="text-truncate">{{ item.name }}</td>
              <td class="text-truncate">{{ item.description ?? "-" }}</td>
              <td>{{ item.price | currency:'BRL':'symbol':'1.2-2' }}</td>
              <td>{{ item.code ?? "-" }}</td>
              <td
                [ngClass]="
                  item.actived === true ? 'text-success' : 'text-danger'
                "
              >
                {{ (item.actived === true ? 'kanban.product.statusActive' : 'kanban.product.statusInactive') | translate }}
              </td>
              <td>
                <div class="d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="menu"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="edit(item)">
                      {{ 'kanban.product.edit' | translate }}
                    </button>
                    @if (isAdmin()) {
                    <button mat-menu-item tabindex="0" (click)="delete(item)">
                      {{ 'kanban.product.delete' | translate }}
                    </button>
                    }
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    </div>
  </div>
}
